<template>
  <el-dialog
  :visible="dialogVisible"
  width="75%"
  :before-close="handleClose"
  class="pub_dialog"
  >
     <div  class="p-title">{{title}}
    <span v-show="title==='课堂不规范行为的学生'">(为方便查看，不规范行为按周为单位统计，不满一周则自动补充为一周)</span>
  </div>
  <header class="p-header">
      <span>学科：</span>
      <el-select v-model="subjectId" placeholder="请选择学科" @change="subjectChange" v-if="type!=='4'">
        <el-option
          v-for="item in classSubjectList"
          :key="item.subject_id"
          :label="item.subject_name"
          :value="item.subject_id">
        </el-option>
      </el-select>
      <el-select v-model="subjectKnowId"
      placeholder="请选择学科" @change="subjectKnowChange" v-if="type==='4'">
        <el-option
          v-for="item in knowSubjectList"
          :key="item.subject_id"
          :label="item.subject_name"
          :value="item.subject_id">
        </el-option>
      </el-select>
      <!-- <span v-if="type==='4'">课程：</span>
      <el-select v-if="type==='4'" v-model="courseId" placeholder="请选择课程"
      @change="courseChange" >
        <el-option
          v-for="item in courseList"
          :key="item.course_id"
          :label="item.course_name"
          :value="item.course_id">
        </el-option>
      </el-select> -->
      <span>搜索：</span>
      <el-input
        placeholder="请输入学生姓名"
        v-model="studentName"
        @input="inputChange"
        @keyup.enter.native="checkStudent"
        >
        <i slot="suffix" class="el-input__icon el-icon-search" @click="checkStudent"></i>
      </el-input>
      <span v-if="type!=='4'">时间：</span>
       <!-- <el-date-picker
        v-if="type!=='4'"
          popper-class="picker-ppp"
          @change="pickChange"
          v-model="dateRange"
          type="daterange"
          unlink-panels
          range-separator="至"
          :default-value="Date.now() - 29 * 24 * 3600 * 1000"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :picker-options="pickerOptions"
          >
      </el-date-picker> -->
      <div class="week-picker-wrapper" v-if="type!=='4'">
        <el-date-picker
          ref="weekPicker"
          popper-class="picker-ppp"
          @change="pickChange"
          v-model="dateRange"
          type="week"
          value-format="yyyy-MM-dd"
          range-separator="至"
          :default-value="Date.now() - 29 * 24 * 3600 * 1000"
          :picker-options="pickerOptions"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          class="week-picker-input"
          >
        </el-date-picker>
        <div class="week-picker-display" @click="openWeekPicker">
          <i class="el-icon-date"></i>
          <span>{{ weekDisplayText }}</span>
        </div>
      </div>
      <div v-if="type==='4'" style="margin-left: 20px; display: flex;">
      <span>时间：</span>
        <div class="week-picker-wrapper">
          <el-date-picker
            ref="knowLedgeWeekPicker"
            popper-class="picker-ppp"
            @change="pickKnowLedgeChange"
            v-model="knowLedgeRange"
            type="week"
            value-format="yyyy-MM-dd"
            range-separator="至"
            :default-value="Date.now() - 29 * 24 * 3600 * 1000"
            :picker-options="pickerOptions"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            class="week-picker-input"
            >
          </el-date-picker>
          <div class="week-picker-display" @click="openKnowLedgeWeekPicker">
            <i class="el-icon-date"></i>
            <span>{{ knowLedgeWeekDisplayText }}</span>
          </div>
        </div>
      </div>
  </header>

  <div class="overview-stu">
    <div class="overview-stu__empty" v-if="type==='2'"></div>
      <ul class="overview-stu__habit" v-if="type!=='2'&&type!=='4'">
        <li  v-for="item in List"
          :key="item.id"
          :class="{'isactive': item.id===activeId}"
          @click="tabChange(item.id)">{{item.name}}</li>
      </ul>
    <div class="overview-stu__out" @click="exportReport">
        <img src="../../images/leading-out.png" alt="">
        导出数据</div>
  </div>
  <!-- <60%就是红底红字否则蓝底蓝字 -->
  <div class="overview-time" :style="{'background':question.avg_right_rate<60&&
  question.avg_right_rate>0?'#FEE9E9':'#DDEEFE'}">
      <p v-if="type==='1'|| type==='3'">
        {{start}}~{{end}}期间，<span>{{subjectName}}</span>科目中，班级<span>
          <p v-if="activeId===0">
            平均测学知识点<span>{{
              knowledge.class_tagcode_cnt==-1?0:knowledge.class_tagcode_cnt}}</span>个，
            平均发现漏洞<span>{{
              knowledge.class_tagcode_fail_cnt==-1?0:knowledge.class_tagcode_fail_cnt}}</span>个，
            平均攻克薄弱知识点<span>{{
              knowledge.class_tagcode_pass_cnt == -1?
               0:knowledge.class_tagcode_pass_cnt}}</span>个
          </p>
          <p v-if="activeId===1">
              平均答题数
            <span>
              {{question.avg_q_num===-1?'--': question.avg_q_num}}
            </span>个，
            {{`${subjectId===3?'主观题':'客观题'}平均正答率`}}
             <span>
            {{ question.avg_right_rate ===-1?
            '--':
            Math.floor(question.avg_right_rate * 100)}}
            </span>%，
            班级平均学习时长
            <span>{{question.avg_study_time}}
            </span>分钟
          </p>
        </span>
      </p>
       <p v-else-if="type==='2'">
        {{start}}~{{end}}期间，<span>{{subjectName}}</span>科目中，
        班级平均不规范行为共<span>{{habit.warn_average}}</span>次，
        平均连续答错次数<span>{{habit.warn_wrong_answer_average}}</span>次，
        平均视频不认真看次数<span>{{habit.warn_video_average}}</span>次，
        平均长时间发呆次数<span>{{habit.warn_no_action_average}}</span>次
      </p>
       <p v-else-if="type==='4'">
        {{start}}~{{end}}期间，<span>{{subjectKnowName}}</span>科目中<span>
          {{courseId===0?'全部课程':courseName}}</span>中，
        学前平均掌握程度<span>{{avg_ability_before===-1?'--':avg_ability_before}}</span>%，
        学后平均掌握程度
        <span>{{avg_ability_after===-1?'--':avg_ability_after}}</span>%，
        平均提升<span>{{ avg_ability_before === -1 || avg_ability_after === -1 ? '--': improve}}</span>%
      </p>
  </div>
    <div v-show="type==='1'||type==='3'">
    <el-table
      :data="tableList"
      style="width: 100%"
      v-show="activeId===0"
      >
      <div slot="empty" class="no-data">
        <EmptyContent/>
      </div>
      <el-table-column
        label="序号"
        type="index"
        width="50"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="student_name"
        label="学生姓名"
        align="center"
       >
      </el-table-column>
       <el-table-column
        prop="tagcode_cnt"
        label="总共测学知识点总个数"
        align="center"
        sortable
       >
        <template slot-scope="scope">
            {{scope.row.tagcode_cnt === -1 ? '--':scope.row.tagcode_cnt}}个
        </template>
      </el-table-column>
       <!-- <el-table-column
        prop="tagcode_finsh_cnt"
        label="学完知识点个数"
        align="center"
        sortable
       >
       <template slot-scope="scope">
             {{scope.row.tagcode_finsh_cnt === -1 ? '--':scope.row.tagcode_finsh_cnt}}个
        </template>
      </el-table-column> -->
       <el-table-column
        prop="tagcode_fail_cnt"
        label="发现漏洞知识点个数"
        align="center"
        sortable
       >
       <template slot-scope="scope">
            {{scope.row.tagcode_fail_cnt === -1 ? '--':scope.row.tagcode_fail_cnt}}个
       </template>
      </el-table-column>
      <el-table-column
        prop="tagcode_pass_cnt"
        label="攻克薄弱知识点个数"
        align="center"
        sortable
       >
       <template slot-scope="scope">
             {{scope.row.tagcode_pass_cnt === -1 ? '--':scope.row.tagcode_pass_cnt}}个
          </template>
      </el-table-column>
      <el-table-column
        label="操作"
        width="150"
        align="center"
      >
      <template slot-scope="scope">
            <div @click="goStudentDetail(scope.row)" class="go-detail">
             查看个人学情
            </div>
          </template>
      </el-table-column>
    </el-table>
    <el-table
      :data="tableList"
      style="width: 100%"
      v-show="activeId===1"
      >
      <div slot="empty" class="no-data">
        <EmptyContent/>
      </div>
      <el-table-column
        label="序号"
        type="index"
        width="50"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="student_name"
        label="学生姓名"
        align="center"
       >
      </el-table-column>
       <el-table-column
        prop="q_num"
        label="总答题数"
        align="center"
        sortable
       >
       <template slot-scope="scope">
            {{scope.row.q_num === -1?'--':scope.row.q_num}}
        </template>
      </el-table-column>
       <el-table-column
       v-if="subjectId!==3"
        prop="lv"
        label="客观题正答率"
        align="center"
        sortable
       >
        <template slot-scope="scope">
            {{scope.row.lv === -1 ? '--' : Math.round(scope.row.lv * 100)}}%
        </template>
      </el-table-column>
      <el-table-column
      v-if="subjectId===3"
        prop="lv"
        label="主观题正答率"
        align="center"
        sortable
       >
        <template slot-scope="scope">
            {{scope.row.lv === -1?'--':scope.row.lv}}%
        </template>
      </el-table-column>
       <el-table-column
        prop="study_time"
        label="总学习时长"
        align="center"
        sortable
       >
       <template slot-scope="scope">
            {{scope.row.study_time === -1 ? '--':scope.row.study_time}}分钟
        </template>
      </el-table-column>
       <el-table-column
        prop="study_video_time"
        label="看视频时长"
        align="center"
        sortable
       >
       <template slot-scope="scope">
            {{scope.row.study_video_time === -1 ? '--':scope.row.study_video_time}}分钟
        </template>
      </el-table-column>
      <el-table-column
        prop="study_practice_time"
        label="练习时长"
        align="center"
        sortable
       >
       <template slot-scope="scope">
            {{scope.row.study_practice_time === -1 ? '--':scope.row.study_practice_time}}分钟
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        width="150"
        align="center"
      >
      <template slot-scope="scope">
            <div @click="goStudentDetail(scope.row)" class="go-detail">
             查看个人学情
            </div>
          </template>
      </el-table-column>
    </el-table>

    </div>
     <div v-show="type==='2'">
       <el-table
      :data="tableList"
      style="width: 100%"
      >
      <div slot="empty" class="no-data">
        <EmptyContent/>
      </div>
      <el-table-column
        label="序号"
        type="index"
        width="50"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="student_name"
        label="学生姓名"
        align="center"
       >
      </el-table-column>
       <el-table-column
        prop="warn_cnt"
        label="课堂不规范行为总次数"
        align="center"
        sortable
       >
       <template slot-scope="scope">
            {{scope.row.warn_cnt}}次
        </template>
      </el-table-column>
       <el-table-column
        prop="warn_cnt_detail.warn_wrong_answer_cnt"
        label="连续答错次数"
        align="center"
        sortable
       >
        <template slot-scope="scope">
            {{scope.row.warn_cnt_detail
            &&scope.row.warn_cnt_detail.warn_wrong_answer_cnt === -1?
            '--':scope.row.warn_cnt_detail&&scope.row.warn_cnt_detail.warn_wrong_answer_cnt}}次
        </template>
      </el-table-column>
       <el-table-column
        prop="warn_cnt_detail.warn_video_cnt"
        label="视频不认真看次数"
        align="center"
        sortable
       >
        <template slot-scope="scope">
            {{scope.row.warn_cnt_detail&&scope.row.warn_cnt_detail.warn_video_cnt===-1?'--':
            scope.row.warn_cnt_detail&&scope.row.warn_cnt_detail.warn_video_cnt}}次
        </template>
      </el-table-column>
      <el-table-column
        prop="warn_cnt_detail.warn_no_action_cnt"
        label="长时间发呆次数"
        align="center"
        sortable
       >
        <template slot-scope="scope">
            {{scope.row.warn_cnt_detail&&scope.row.warn_cnt_detail.warn_no_action_cnt===-1?
            '--':scope.row.warn_cnt_detail&&scope.row.warn_cnt_detail.warn_no_action_cnt}}次
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        width="150"
        align="center"
      >
      <template slot-scope="scope">
            <div @click="goStudentDetail(scope.row)" class="go-detail">
             查看个人学情
            </div>
          </template>
      </el-table-column>
    </el-table>
    </div>
    <div v-show="type==='4'">
       <el-table
      :data="tableList"
      style="width: 100%"
      >
      <div slot="empty" class="no-data">
        <EmptyContent/>
      </div>
      <el-table-column
        label="序号"
        type="index"
        width="50"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="student_name"
        label="学生姓名"
        align="center"
       >
      </el-table-column>
       <el-table-column
        prop="avg_ability_before"
        label="学习前测评平均掌握程度"
        align="center"
        sortable
       >
        <template slot-scope="scope">
            {{scope.row.avg_ability_before === -1 ? '--':scope.row.avg_ability_before}}%
        </template>
      </el-table-column>
       <el-table-column
        prop="avg_ability_after"
        label="学习后平均掌握程度"
        align="center"
        sortable
       >
        <template slot-scope="scope">
           {{scope.row.avg_ability_after === -1 ? '--':scope.row.avg_ability_after}}%
        </template>
      </el-table-column>
       <el-table-column
        prop="avg_ability"
        label="平均掌握程度提升"
        align="center"
        sortable
       >
        <template slot-scope="scope">
          {{scope.row.avg_ability === -1 ? '--': Math.max(0, scope.row.avg_ability || 0) }}%
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        width="150"
        align="center"
      >
      <template slot-scope="scope">
            <div @click="goStudentDetail(scope.row)" class="go-detail">
             查看个人学情
            </div>
          </template>
      </el-table-column>
    </el-table>
    </div>

  </el-dialog>
</template>

<script>
import dayjs from 'dayjs';
import {
  getClassStudentLearnDetail, getClassHabitList, tagCodeStudySituationDetail,
  studentInfo,
} from '@/api/pt';
import EmptyContent from '@/views/pt/components/empty.vue';
import { subjectIdToSubjectName } from '@/utils/index';

export default {
  name: 'DialogContent',
  components: {
    EmptyContent,
  },
  props: {
    dialogVisible: {
      default: false,
      type: Boolean,
    },
    title: {
      default: '',
      type: String,
    },
    // 弹窗类型 正答率较低 1 课堂不规范行为 2 班级近况 3 班级知识点学情明细 4
    type: {
      default: '1',
      type: String,
    },
    // 上个页面的参数带过来
    studyResults: {
      default: () => {},
    },
    schoolMasterClassId: {
      type: [String, Number],
      default: null,
    },
    masterClassId: {
      type: [String, Number],
      default: null,
    },
  },
  data() {
    const getDefaultWeekRange = () => {
      const today = dayjs();
      const day = today.day();
      const monday = day === 0 ? today.subtract(6, 'day') : today.subtract(day - 1, 'day');
      // type="week" 时，返回周一日期字符串（符合 value-format="yyyy-MM-dd"）
      return monday.format('YYYY-MM-DD');
    };
    return {
      studentName: '',
      pickerMinDate: '',
      pickerOptions: {
        firstDayOfWeek: 1,
        // shortcuts: [{
        //   text: '最近7天',
        //   onClick(picker) {
        //     const end = new Date();
        //     const start = new Date();
        //     start.setTime(start.getTime() - 3600 * 1000 * 24 * 6);
        //     picker.$emit('pick', [start, end]);
        //   },
        // },
        // {
        //   text: '最近14天',
        //   onClick(picker) {
        //     const end = new Date();
        //     const start = new Date();
        //     start.setTime(start.getTime() - 3600 * 1000 * 24 * 13);
        //     picker.$emit('pick', [start, end]);
        //   },
        // },
        // {
        //   text: '最近30天',
        //   onClick(picker) {
        //     const end = new Date();
        //     const start = new Date();
        //     start.setTime(start.getTime() - 3600 * 1000 * 24 * 29);
        //     picker.$emit('pick', [start, end]);
        //   },
        // }],
        // onPick: ({ maxDate, minDate }) => {
        //   this.pickerMinDate = minDate.getTime();
        //   if (maxDate) {
        //     this.pickerMinDate = '';
        //   }
        // },
        // disabledDate: (time) => {
        //   if (this.pickerMinDate !== '') {
        //     const day30 = (30 - 1) * 24 * 3600 * 1000;
        //     let maxTime = this.pickerMinDate + day30;
        //     if (maxTime > new Date()) {
        //       maxTime = new Date();
        //       return time.getTime() > maxTime || time.getTime() < this.pickerMinDate - day30;
        //     }
        //     return maxTime < time.getTime() || time.getTime() < this.pickerMinDate - day30;
        //   }
        //   return time.getTime() > Date.now();
        // },
      },
      List: [{
        name: '知识点情况',
        id: 0,
      }, {
        name: '做题情况',
        id: 1,
      }],
      knowList: [],
      activeId: 0,
      start: '',
      end: '',
      tabType: 1,
      dateRange: getDefaultWeekRange(),
      subjectId: '',
      subjectName: '',
      classSubjectList: [],
      studentId: '',
      studentList: [],
      /* 4 */
      knowLedgeRange: getDefaultWeekRange(),
      subjectKnowId: '',
      subjectKnowName: '',
      courseId: '',
      courseName: '',
      courseList: [],
      knowLedgeParams: {},
      // 1 ,3
      knowledge: {
        class_tagcode_cnt: '', // 平均总共测学知识点总次数
        class_tagcode_fail_cnt: '', // 平均发现漏洞知识点次数
        class_tagcode_pass_cnt: '', // 平均攻克薄弱知识点次数
        list: [],
      },
      question: {
        avg_q_num: '', // 平均总答题数
        avg_right_rate: '', // 平均正确率
        avg_study_time: '', // 班级平均学习时长
        list: [],
      },
      params: {},
      // 2
      habit: {
        warn_average: '', // 时间区间内 班级不良习惯平均数
        warn_wrong_answer_average: '',
        warn_video_average: '',
        warn_no_action_average: '',
      },
      // 4
      avg_ability_before: '',
      avg_ability_after: '',
      improve: '',
      tableList: [
      ],
    };
  },
  methods: {
    // 打开日期选择器
    openWeekPicker() {
      if (!this.$refs.weekPicker) {
        return;
      }
      // 通过点击输入框来打开选择器
      const input = this.$refs.weekPicker.$el.querySelector('input');
      if (input) {
        input.click();
        return;
      }
      // 如果找不到输入框，尝试直接设置 visible
      if (this.$refs.weekPicker.pickerVisible !== undefined) {
        this.$refs.weekPicker.pickerVisible = true;
      }
    },
    // 打开知识点日期选择器
    openKnowLedgeWeekPicker() {
      if (!this.$refs.knowLedgeWeekPicker) {
        return;
      }
      // 通过点击输入框来打开选择器
      const input = this.$refs.knowLedgeWeekPicker.$el.querySelector('input');
      if (input) {
        input.click();
        return;
      }
      // 如果找不到输入框，尝试直接设置 visible
      if (this.$refs.knowLedgeWeekPicker.pickerVisible !== undefined) {
        this.$refs.knowLedgeWeekPicker.pickerVisible = true;
      }
    },
    handleClose() {
      this.$emit('update:dialogVisible', false);
      this.studentName = '';
    },
    // 时间选择切换
    pickChange() {
      if (!this.dateRange) {
        return;
      }
      this.studentName = '';
      // type="week" 时，dateRange 是单个日期字符串（格式：yyyy-MM-dd）
      let selectedDate;
      if (Array.isArray(this.dateRange)) {
        if (this.dateRange.length < 1) {
          return;
        }
        const [firstDate] = this.dateRange;
        selectedDate = firstDate;
      } else {
        selectedDate = this.dateRange;
      }
      // 计算该周的周一和周日
      const [weekStart, weekEnd] = this.getAlignedWeekRange(selectedDate);
      // 更新 dateRange：type="week" 时保持为单个日期字符串（周一）
      this.dateRange = weekStart.format('YYYY-MM-DD');
      // 更新参数
      this.params = this.$store.state.LearnDetailObj;
      this.params.start_time = weekStart.format('YYYYMMDD');
      this.params.end_time = weekEnd.format('YYYYMMDD');
      this.params.subject_id = this.subjectId;
      delete this.params.crm_subject_id;
      this.start = weekStart.format('YYYY.MM.DD');
      this.end = weekEnd.format('YYYY.MM.DD');
      // 更新 store
      this.$store.commit('SET_CLASS_DATE_RANGE', [weekStart.toDate(), weekEnd.toDate()]);

      if (this.type === '1' || this.type === '3') {
        this.params.type = this.tabType;
        this.getClassStudentLearnDetail();
      } else if (this.type === '2') {
        this.getClassHabitList();
      }
    },
    pickKnowLedgeChange() {
      if (!this.knowLedgeRange) {
        return;
      }
      // type="week" 时，knowLedgeRange 是单个日期字符串（格式：yyyy-MM-dd）
      let selectedDate;
      if (Array.isArray(this.knowLedgeRange)) {
        if (this.knowLedgeRange.length < 1) {
          return;
        }
        const [firstDate] = this.knowLedgeRange;
        selectedDate = firstDate;
      } else {
        selectedDate = this.knowLedgeRange;
      }
      // 计算该周的周一和周日
      const [weekStart, weekEnd] = this.getAlignedWeekRange(selectedDate);
      // 更新 knowLedgeRange：type="week" 时保持为单个日期字符串（周一）
      this.knowLedgeRange = weekStart.format('YYYY-MM-DD');
      // 更新参数
      this.knowLedgeParams = this.$store.state.knowLedgeParams;
      this.start = weekStart.format('YYYY.MM.DD');
      this.end = weekEnd.format('YYYY.MM.DD');
      this.knowLedgeParams.subject_id = this.subjectKnowId;
      this.knowLedgeParams.course_id = this.courseId;
      this.knowLedgeParams.school_master_class_id = this.schoolMasterClassId || this.masterClassId;
      this.knowLedgeParams.start_time = weekStart.format('YYYYMMDD');
      this.knowLedgeParams.end_time = weekEnd.format('YYYYMMDD');
      this.knowLedgeParams.school_id = this.params.school_id;
      const params = this.knowLedgeParams;
      delete params.dateRange;
      // 更新 store
      this.$store.commit('SET_KNOWLEDGE_RANGE', [weekStart.toDate(), weekEnd.toDate()]);
      this.tagCodeStudySituationDetail(params);
    },
    // 弹框内tab切换
    tabChange(id) {
      this.activeId = id;
      this.studentName = '';
      if (id === 0) {
        this.tabType = 1;
        this.pickChange();
      } else if (id === 1) {
        this.tabType = 2;
        this.pickChange();
      }
    },
    clickItem(index) {
      if (this.subjectId === 1 || this.subjectId === 3 || index > 3) {
        this.activeId = 1;
        this.tabType = 2;
        this.pickChange();
      } else if (index > 0 && index <= 3) {
        this.activeId = 0;
        this.tabType = 1;
        this.pickChange();
      }
    },
    subjectChange(val) {
      this.subjectId = val;
      this.subjectName = subjectIdToSubjectName(val);
    },
    subjectKnowChange(val) {
      this.subjectKnowId = val;
      this.subjectKnowName = subjectIdToSubjectName(val);
      this.studentName = '';
      // this.courseId = 0;
      this.knowLedgeParams.subject_id = this.subjectKnowId;
      const params = this.knowLedgeParams;
      this.tagCodeStudySituationDetail(params);
    },
    courseChange(val) {
      this.courseId = val;
      this.pickKnowChange();
    },
    goStudentDetail(row) {
      this.studentId = row.account_id;
      this.getStudentInfo();
    },
    async getStudentInfo() {
      if (this.type === '4') {
        this.classId = this.knowLedgeParams.class_id;
      } else {
        this.classId = this.params.class_id;
      }
      const res = await studentInfo(
        {
          account_id: this.studentId,
          class_id: this.classId,
        },
      );
      const routerParams = res.data;
      this.$router.push({
        path: '/pt/home-analysis',
        query: {
          account_id: routerParams.account_id,
          class_id: routerParams.class_id,
          school_id: routerParams.school_id,
          account_name: routerParams.account_name,
          study_day: routerParams.study_day,
          avatar: routerParams.avatar,
          created: routerParams.created,
        },
        // query: {
        //   account_id: '8885623813716550',
        //   account_name: '小学风雨',
        //   avatar: 'https://game.test.classba.cnhttps://game.test.classba.cn/share/icon/squirrel_metal1.png',
        //   class_id: '636257598013812736',
        //   created: '2021-09-17 15:02:30',
        //   school_id: 20043,
        //   study_day: 120,
        // },
      });
      this.$emit('update:dialogVisible', false);
    },
    // 1,3
    async getClassStudentLearnDetail() {
      const res = await getClassStudentLearnDetail(this.params);
      this.knowledge = res.data.knowledge;
      this.question = res.data.question;
      if (this.activeId === 0) {
        this.tableList = this.knowledge && this.knowledge.list;
      } else {
        this.tableList = this.question && this.question.list;
      }
      this.studentList = this.tableList;
    },
    // 2
    async getClassHabitList() {
      const res = await getClassHabitList(this.params);
      this.habit.warn_average = res.data.warn_average;
      this.habit.warn_no_action_average = res.data.warn_no_action_average;
      this.habit.warn_video_average = res.data.warn_video_average;
      this.habit.warn_wrong_answer_average = res.data.warn_wrong_answer_average;
      this.tableList = res.data.habit_improve_list;
      this.studentList = this.tableList;
    },
    // 4
    async tagCodeStudySituationDetail(params) {
      const res = await tagCodeStudySituationDetail(params);
      this.avg_ability_before = res.data.study_before_lv;
      this.avg_ability_after = res.data.study_after_lv;
      this.improve = Math.max(0, this.avg_ability_after - this.avg_ability_before);
      this.tableList = res.data.list;
      this.studentList = this.tableList;
    },
    // 导出数据
    exportReport() {
      let address = '';
      const hostName = window.location.hostname;
      if (hostName === 'pschool.songshuai.com') {
        address = 'https://pschool-api.songshuai.com';
      } else if (hostName === 'pschool-pre.songshuai.com') {
        address = 'https://pschool-api-pre.songshuai.com';
      } else if (hostName === 'pschool-test.songshuai.com') {
        address = 'https://pschool-api-test.songshuai.com';
      } else if (hostName === 'pschool.fe.dev.myyixue.com') {
        address = 'http://pschool-api.be.dev.myyixue.com';
      } else {
        address = 'http://pschool-api.be.dev.myyixue.com';
      }
      if (this.type === '1' || this.type === '3') {
        const url = `${address}/pt/api/v2/classOverview/exportClassStudentLearnDetail
        ?class_id=${this.params.class_id}&school_id=${this.params.school_id}&school_master_class_id=${this.params.school_master_class_id || this.masterClassId}&subject_id=${this.params.subject_id}&start_time=${this.params.start_time}&end_time=${this.params.end_time}&type=${this.tabType}`;
        window.location.href = url;
      } else if (this.type === '2') {
        const url = `${address}/pt/api/v2/classOverview/classHabitExport
        ?class_id=${this.params.class_id}&school_id=${this.params.school_id}&school_master_class_id=${this.params.school_master_class_id || this.masterClassId}&subject_id=${this.params.subject_id}&start_time=${this.params.start_time}&end_time=${this.params.end_time}`;
        window.location.href = url;
      } else if (this.type === '4') {
        const list = this.courseList.filter((item) => item.course_id === this.courseId);
        this.courseName = list && list.length > 0 ? list[0].course_name : '';
        const url = `${address}/pt/api/v2/class/exportTagCodeStudySituation
        ?class_id=${this.knowLedgeParams.class_id}&school_id=${this.knowLedgeParams.school_id}&course_id=${this.knowLedgeParams.course_id}&course_name=${this.courseName}&school_master_class_id=${this.params.school_master_class_id || this.masterClassId}&subject_id=${this.knowLedgeParams.subject_id}&start_time=${this.knowLedgeParams.start_time}&end_time=${this.knowLedgeParams.end_time}`;
        window.location.href = url;
      }
    },
    // 查询学生
    checkStudent() {
      this.tableList = this.studentList
        .filter((item) => item.student_name.includes(this.studentName));
    },
    inputChange(val) {
      if (val === '') {
        this.tableList = this.studentList;
      }
    },
    getAlignedWeekRange(date) {
      const target = dayjs(date);
      const day = target.day();
      const monday = day === 0 ? target.subtract(6, 'day') : target.subtract(day - 1, 'day');
      const sunday = monday.add(6, 'day');
      return [monday, sunday];
    },
  },
  created() {
  },
  mounted() {
  },
  computed: {
    weekDisplayText() {
      if (!this.dateRange) {
        return '请选择日期';
      }
      let selectedDate;
      if (Array.isArray(this.dateRange)) {
        if (this.dateRange.length < 1) {
          return '请选择日期';
        }
        const [firstDate] = this.dateRange;
        selectedDate = firstDate;
      } else {
        selectedDate = this.dateRange;
      }
      const [weekStart, weekEnd] = this.getAlignedWeekRange(selectedDate);
      return `${weekStart.format('YYYY-MM-DD')} 至 ${weekEnd.format('YYYY-MM-DD')}`;
    },
    knowLedgeWeekDisplayText() {
      if (!this.knowLedgeRange) {
        return '请选择日期';
      }
      let selectedDate;
      if (Array.isArray(this.knowLedgeRange)) {
        if (this.knowLedgeRange.length < 1) {
          return '请选择日期';
        }
        const [firstDate] = this.knowLedgeRange;
        selectedDate = firstDate;
      } else {
        selectedDate = this.knowLedgeRange;
      }
      const [weekStart, weekEnd] = this.getAlignedWeekRange(selectedDate);
      return `${weekStart.format('YYYY-MM-DD')} 至 ${weekEnd.format('YYYY-MM-DD')}`;
    },
  },
  watch: {
    '$store.state.classSubjectId': {
      deep: true,
      immediate: true,
      handler(n) {
        this.subjectId = n;
        this.subjectName = subjectIdToSubjectName(n);
      },
    },
    '$store.state.classDateRange': {
      deep: true,
      immediate: true,
      handler(n) {
        // store 中可能是数组格式，需要转换为字符串格式
        if (n && Array.isArray(n) && n.length > 0) {
          const [weekStart] = this.getAlignedWeekRange(n[0]);
          this.dateRange = weekStart.format('YYYY-MM-DD');
        } else if (n && !Array.isArray(n)) {
          this.dateRange = n;
        }
      },
    },
    '$store.state.knowLedgeRange': {
      deep: true,
      immediate: true,
      handler(n) {
        // store 中可能是数组格式，需要转换为字符串格式
        if (n && Array.isArray(n) && n.length > 0) {
          const [weekStart] = this.getAlignedWeekRange(n[0]);
          this.knowLedgeRange = weekStart.format('YYYY-MM-DD');
        } else if (n && !Array.isArray(n)) {
          this.knowLedgeRange = n;
        }
      },
    },
    '$store.state.knowLedgeParams': {
      deep: true,
      immediate: true,
      handler(n, o) {
        console.log(n, o, '00000000');
        this.subjectKnowId = n.subject_id;
        this.subjectKnowName = subjectIdToSubjectName(n.subject_id);
        this.courseList = this.$store.state.classCourseList;
        this.courseId = n.course_id;
        const list = this.courseList.filter((item) => item.course_id === this.courseId);
        this.courseName = list && list.length > 0 ? list[0].course_name : '';
      },
    },
    type: {
      deep: true,
      immediate: true,
      handler() {
        this.classSubjectList = this.$store.state.classSubjectList;
        this.knowSubjectList = this.$store.state.knowSubjectList;
        if (!this.knowSubjectList || this.knowSubjectList.length === 0) {
          this.knowSubjectList = JSON.parse(sessionStorage.getItem('knowSubjectList'));
          this.$store.commit('SET_KNOW_SUBJECT_LIST', this.knowSubjectList);
        }
        this.courseList = this.$store.state.classCourseList;
      },

    },
    subjectId: {
      deep: true,
      immediate: true,
      handler(n) {
        console.log(n, 'nxxxxxxxxxx');
        this.List = [{
          name: '知识点情况',
          id: 0,
        }, {
          name: '做题情况',
          id: 1,
        }];
        this.activeId = 0;
        this.tabType = 1;
        this.pickChange();
      },

    },
  },
};
</script>

<style lang="scss" scoped>
// dialog自定义

.p-title{
  font-size: 20px;
  font-weight: 500;
  color: #111F2C;
  margin-bottom: 16px;
  span{
    font-weight: 400;
    color: #909399;
    font-size: 13px;
  }
}
.p-header {
  display: flex;
  flex-wrap: wrap;
  span{
    line-height: 40px;
    font-size: 16px;
    color: #000000;
    margin-left: 20px;
    &:first-child{
      margin:0
    }
  }
}
.overview-stu{
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 18px;
  margin-top: 28px;
   span{
    line-height: 40px;
    font-size: 16px;
    color: #000000;
  }
  &__habit{
    display: flex;
    font-size: 14px;
    // width: 244px;
    height: 40px;
    background: #F0F2F5;
    border-radius: 4px;
    padding: 2px;
    line-height: 40px;
    box-sizing: border-box;
    position: relative;
    color: #303133;
    li {
      width: 120px;
      text-align: center;
      cursor: pointer;
      font-weight: 500;
    }
  }
  &__empty{
    width: 244px;
    height: 40px;
  }
  &__out{
    font-size: 15px;
    font-weight: 500;
    color: #1989FA;
    cursor: pointer;
    img{
      width: 16px;
      vertical-align: middle;
      margin-right: 3px;
    }
  }
}
.overview-time{
  // height: 52px;
  background: #FEE9E9;
  border-radius: 4px;
  // line-height: 52px;
  padding:15px 20px;
  margin-bottom: 18px;
  p{
    display: inline;
    font-size: 17px;
    font-weight: 500;
    color: #343639;
    span{
     color: #1989FA;
    //  &:last-child{
    //  color: #F56C6C;
    //  }
    }
  }
}
.week-picker-wrapper {
    position: relative;
    display: inline-block;
    .week-picker-input {
      /deep/ .el-input__inner {
        opacity: 0;
        position: absolute;
        z-index: 1;
        cursor: pointer;
      }
    }
    .week-picker-display {
      position: absolute;
      left: 0;
      top: 0;
      width: 240px;
      height: 40px;
      line-height: 40px;
      padding: 0 15px 0 30px;
      border: 1px solid #DCDFE6;
      border-radius: 4px;
      background-color: #fff;
      cursor: pointer;
      font-size: 14px;
      color: #606266;
      box-sizing: border-box;
      z-index: 0;
      display: flex;
      align-items: center;
      &:hover {
        border-color: #C0C4CC;
      }
      .el-icon-date {
        position: absolute;
        left: 10px;
        font-size: 16px;
        color: #C0C4CC;
        pointer-events: none;
      }
      span {
        flex: 1;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }
.isactive {
  color: #1989FA;
  background: #FFFFFF;
  border-radius: 2px;
}
.go-detail{
  font-size: 14px;
  font-weight: 500;
  color: #1989FA;
  cursor: pointer;
}
::v-deep{
   .el-table{
    font-size: 14px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #606266;
    .el-table__header th {
    background-color: #F0F2F5;;
    }
  }
  .el-dialog__header{
    padding: 0;
  }
.el-select{
  .el-input--suffix{
      width: 180px;
    }
  }
  .el-input--suffix{
    width: 220px;
  }
  .el-date-editor--daterange{
    width: 260px;
  }
  .el-dialog__title{
  font-size: 20px;
  font-weight: 500;
  color: #111F2C;
  }

  .el-dialog {
        margin: 40px auto !important;
        height: 80%;
        overflow: hidden;
        .el-dialog__body {
            position: absolute;
            padding: 0px 20px;
            left: 0;
            top: 40px;
            bottom: 0;
            right: 0;
            z-index: 1;
            overflow: hidden;
            overflow-y: auto;
        }
    }
}
</style>
